import React, { useState } from 'react';
import { ReactComponent as Close } from '../../../assets/images/teamclose.svg';
import Input from '../../common/InputField';
import { styled } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import { ReactComponent as Check } from "../../../assets/images/check.svg";
import { useDispatch, useSelector } from 'react-redux';
import { sendTranscript } from '../../../store/features/sendTranscript';
import { toast } from 'react-toastify';

function ChatTranscriptPopUp(props) {
  const { setTranscriptPopup, selectUser } = props;
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.sendTranscript?.isLoading);
  const [email, setEmail] = useState('');
  const [includeSystemMessages, setIncludeSystemMessages] = useState(false);

  const BlueRoundedCheckbox = styled(Checkbox)(({ theme }) => ({
    padding: "0px",
    width: "18px",
    height: "18px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",


    "&.MuiCheckbox-root": {
      color: "transparent",
    },
    "& .MuiSvgIcon-root": {
      width: "18px",
      height: "18px",
      borderRadius: "4px",
      border: "1px solid #D5DCE1",
      backgroundColor: "#FFF",
      boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
      path: {
        display: "none",
      },
    },
    "&.Mui-checked": {
      "& .MuiSvgIcon-root": {
        border: "1px solid #148DFD",
        backgroundColor: "#FFF",
      },
    },
    "&:hover": {
      backgroundColor: "transparent",
      "& .MuiSvgIcon-root": {
        border: "1px solid #148DFD",
      },
    },
  }));

  const roomId = selectUser?.id || selectUser?._id;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      toast.error('Please enter an email address.');
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(trimmedEmail)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    if (!roomId) {
      toast.error('Unable to send transcript: chat room not found.');
      return;
    }

    try {
      const result = await dispatch(
        sendTranscript({ roomId, email: trimmedEmail }),
      );

      if (sendTranscript.fulfilled.match(result)) {
        toast.success(
          result.payload?.message || 'Transcript sent successfully.',
        );
        setTranscriptPopup(false);
        return;
      }

      toast.error(
        result.payload?.message || 'Failed to send transcript.',
      );
    } catch {
      toast.error('Failed to send transcript.');
    }
  };

  return (
    <>
      <div className="overlay" style={{zIndex: 50}}/>
      <div style={{ width: '424px' }} className="Team-PopUp-Container">
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Send chat transcript to email</p>
          <p className="PopUp-Text02" onClick={() => setTranscriptPopup(false)}>
            <Close />
          </p>
        </div>

        <form className="PopUp-Email-Container" onSubmit={handleSubmit}>
          <Input
            type="email"
            id="email"
            name="email"
            title="Enter email"
            placeholder="Enter email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="check__box__chat">
            <div className="block__check__chat">
              <BlueRoundedCheckbox
                color="primary"
                id="myCheckbox_chat"
                checked={includeSystemMessages}
                onChange={(e) => setIncludeSystemMessages(e.target.checked)}
                checkedIcon={
                  <Check
                    style={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "4px",
                      border: "1px solid #148DFD",
                      backgroundColor: "#FFF",
                      padding: '5px 3px 2px 3.5px'
                    }}
                  />
                }
              />

              <label htmlFor="myCheckbox_chat" />
            </div>
            <span className="Remember__01_chat">
              Include also system messages and whispers from supervisors.
            </span>
          </div>

          <div style={{ marginTop: '28px' }} className="Ticket-Button-Container">
            <button
              type="button"
              style={{ width: '175px' }}
              className="buttonstyle-Cancel"
              onClick={() => setTranscriptPopup(false)}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{ width: '175px' }}
              className="buttonstyle-Ticket"
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send transcript'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ChatTranscriptPopUp;
